import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLinkAlt } from '@fortawesome/pro-solid-svg-icons/faExternalLinkAlt';

import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';

import { FileAClaimButton } from '../../../../insurance/components/file-a-claim-button';
import FormattedCurrency from '../../../../components/formatted-currency';
import { InsuranceProviders, getInsuranceProviderById } from '../../../../enums/insurance-providers';
import { InsuranceAmountLabel, InsuranceLabel } from '../../shared-field-labels/shared-field-labels';
import { useFulfillmentDisplayContext } from '../display-context';
import ReadonlyField from './readonly-field';

import messages from './messages';
import style from './style.module.less';

const Insurance = () => {
  const { insurance } = useFulfillmentDisplayContext();
  const { insuranceProviderId, value, currencyCode } = insurance;
  const insuranceProvider = getInsuranceProviderById(insuranceProviderId);

  return (
    <>
      <ReadonlyField className={style.info} label={InsuranceLabel}>
        {insuranceProvider && (
          <>
            <span className={style['insurance-label']}>
              <FormattedMessage {...insuranceProvider.messageDescriptor} />
            </span>
            <FileAClaimButton insuranceProviderName={insuranceProvider.name}>
              {({ url, open }) => (
                <Button href={url} onClick={open} theme='link'>
                  <FormattedMessage {...messages.fileAClaim} />
                  <FontAwesomeIcon className={style['claim-icon']} icon={faExternalLinkAlt} />
                </Button>
              )}
            </FileAClaimButton>
          </>
        )}
      </ReadonlyField>
      {insuranceProvider && insuranceProviderId !== InsuranceProviders.None.insuranceProviderId && (
        <ReadonlyField label={InsuranceAmountLabel}>
          <FormattedCurrency currencyCode={currencyCode} value={value} />
        </ReadonlyField>
      )}
    </>
  );
};

export default Insurance;
